"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Holidays = void 0;
exports.Holidays = [
    {
        date: '2016-01-01',
        description: 'New Year day'
    },
    {
        date: '2016-01-18',
        description: 'Martin Luther King Jr. day'
    },
    {
        date: '2016-02-15',
        description: 'Presidents Day (Washingtons Birthday)'
    },
    {
        date: '2016-05-30',
        description: 'Memorial day'
    },
    {
        date: '2016-07-04',
        description: 'Independence day'
    },
    {
        date: '2016-09-05',
        description: 'Labor day'
    },
    {
        date: '2016-11-24',
        description: 'Thanksgiving day'
    },
    {
        date: '2016-12-26',
        description: 'Christmas day'
    },
    {
        date: '2017-01-02',
        description: 'New Year day'
    },
    {
        date: '2017-01-16',
        description: 'Martin Luther King Jr. day'
    },
    {
        date: '2017-02-20',
        description: 'Presidents Day (Washingtons Birthday)'
    },
    {
        date: '2017-05-29',
        description: 'Memorial day'
    },
    {
        date: '2017-07-04',
        description: 'Independence day'
    },
    {
        date: '2017-09-04',
        description: 'Labor day'
    },
    {
        date: '2017-11-23',
        description: 'Thanksgiving day'
    },
    {
        date: '2017-12-25',
        description: 'Christmas day'
    },
    {
        date: '2018-01-01',
        description: 'New Year day'
    }
];
